import { AppState, Challenge } from '@/types';
import { AppAction } from '../types';
import { 
  initializeChallenges, 
  updateChallengeProgress, 
  getChallengeRewards 
} from '@/lib/challengeSystem';

export function handleInitializeChallenges(state: AppState): AppState {
  // Only initialize if no challenges exist
  if (state.challenges.length === 0) {
    const newChallenges = initializeChallenges();
    return {
      ...state,
      challenges: newChallenges,
      activeChallenges: newChallenges.filter(c => c.status === 'active')
    };
  }
  return state;
}

export function handleUpdateChallengeProgress(
  state: AppState,
  action: Extract<AppAction, { type: 'UPDATE_CHALLENGE_PROGRESS' }>
): AppState {
  const { actionType, activityName } = action.payload;
  
  const updatedChallenges = updateChallengeProgress(
    state.challenges,
    state,
    actionType,
    activityName
  );

  return {
    ...state,
    challenges: updatedChallenges,
    activeChallenges: updatedChallenges.filter(c => c.status === 'active')
  };
}

export function handleCompleteChallenge(
  state: AppState,
  action: Extract<AppAction, { type: 'COMPLETE_CHALLENGE' }>
): AppState {
  const { challengeId } = action.payload;
  const challenge = state.challenges.find(c => c.id === challengeId);
  
  if (!challenge || challenge.status !== 'completed') {
    return state;
  }

  const rewards = getChallengeRewards(challenge);
  
  // Apply rewards
  let newTotalPoints = state.totalPoints + rewards.points;
  let updatedPet = state.virtualPet;
  
  // Add pet items to pet's inventory
  if (updatedPet && rewards.petItems.length > 0) {
    updatedPet = {
      ...updatedPet,
      unlockedItems: {
        ...updatedPet.unlockedItems,
        toys: [...updatedPet.unlockedItems.toys, ...rewards.petItems.filter(item => item.includes('toy'))],
        food: [...updatedPet.unlockedItems.food, ...rewards.petItems.filter(item => item.includes('treat') || item.includes('food'))],
        clothes: [...updatedPet.unlockedItems.clothes, ...rewards.petItems.filter(item => item.includes('collar') || item.includes('badge'))]
      }
    };
  }

  return {
    ...state,
    totalPoints: newTotalPoints,
    virtualPet: updatedPet,
    challenges: state.challenges.map(c => 
      c.id === challengeId ? { ...c, status: 'completed' as const } : c
    )
  };
}